import { globalErrorsSelector } from 'viewModel/selectors/global/globalSelector';
import ErrorConstants from 'utils/ErrorConstants';
import SameDaySkuOOSException from 'components/FrictionlessCheckout/SddSection/SameDayException/SameDaySkuOOSException';
import { createSelector } from 'reselect';
import ErrorUtils from 'utils/Errors';

const { showInlineGlobalError } = ErrorUtils;

const {
    ERROR_CODES: { SAME_DAY_SKU_OOS_EXCEPTION }
} = ErrorConstants;

const errorSelector = createSelector(globalErrorsSelector, globalErrors => {
    let error = null;
    let isSDDSkuOOSException = false;

    const keys = Object.keys(globalErrors).filter(key => {
        const { errorId, errorKey } = globalErrors[key];
        const result = showInlineGlobalError(errorId, errorKey);

        return result;
    });

    if (keys.length) {
        const key = keys[keys.length - 1];

        switch (key) {
            case SAME_DAY_SKU_OOS_EXCEPTION: {
                error = SameDaySkuOOSException;
                isSDDSkuOOSException = true;

                break;
            }
            default: {
                error = globalErrors[key].message;

                break;
            }
        }
    }

    return { error, isSDDSkuOOSException };
});

export { errorSelector };
